import { render, staticRenderFns } from "./prescriptionAudit.vue?vue&type=template&id=40177d56&scoped=true"
import script from "./prescriptionAudit.vue?vue&type=script&lang=js"
export * from "./prescriptionAudit.vue?vue&type=script&lang=js"
import style0 from "./prescriptionAudit.vue?vue&type=style&index=0&id=40177d56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40177d56",
  null
  
)

export default component.exports